import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import { ColorPicker } from "./color-picker";

interface Props<TFieldValues extends FieldValues> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  label?: string;
  required?: boolean;
  disabled?: boolean;
}

export const ColorPickerInput = <TFieldValues extends FieldValues>({
  name,
  control,
  label,
  required,
  disabled,
}: Props<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <ColorPicker
          name={field.name}
          value={field.value}
          onChange={(value) => field.onChange(value)}
          label={`${label}${required ? "*" : ""}`}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          disabled={disabled}
        />
      )}
    />
  );
};
